module.exports = __webpack_public_path__ + "media/application/images/icons/close-white-f991f0a1f879dd166406c238024637b0.svg";